/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personalsignonchrstimascardfrom5Inputs */

const de__field_personalsignonchrstimascardfrom5 = /** @type {(inputs: _Field_Personalsignonchrstimascardfrom5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weihnachtskartenversand personalisiert durch`)
};

/**

* @param {_Field_Personalsignonchrstimascardfrom5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personalsignonchrstimascardfrom5 = /** @type {((inputs?: _Field_Personalsignonchrstimascardfrom5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personalsignonchrstimascardfrom5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personalsignonchrstimascardfrom5(inputs)
});
export { _field_personalsignonchrstimascardfrom5 as "_field_personalSignOnChrstimasCardFrom" }